const appName = 'Quản lý văn bằng'
const apiUrl = '/api/'
// const apiUrl = 'http://qlvbhungha.vn/api/'
export { apiUrl, appName }
